/**
 * Shared Tailwind tokens for the public /welcome pages and their popups.
 *
 * The welcome surface is always dark (it renders over the animated
 * PortalBackground with `forceDark`), so these tokens are single-theme by
 * design — they must not follow the viewer's light/dark toggle.
 */

/** Frosted panel: the base surface for every card, header and modal. */
export const welcomeGlass =
  'border border-white/10 bg-zinc-900/60 backdrop-blur-xl shadow-[0_18px_50px_-24px_rgba(0,0,0,0.9)]';

/** Glass panel that lifts on hover — for cards that are buttons or links. */
export const welcomeGlassInteractive =
  `${welcomeGlass} transition-all duration-300 hover:-translate-y-1 hover:border-white/20`;

/** Quieter inset surface for nested blocks inside a glass card. */
export const welcomeInset = 'rounded-xl border border-white/10 bg-white/[0.03]';

export const welcomePrimaryButton =
  'inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-red-600 to-rose-500 hover:from-red-500 hover:to-rose-400 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-red-900/40 transition-all hover:shadow-xl hover:shadow-red-900/50 active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-red-400 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-900';

export const welcomeGhostButton =
  'inline-flex items-center justify-center gap-2 rounded-xl border border-white/15 bg-white/[0.04] px-5 py-2.5 text-sm font-semibold text-zinc-200 transition-colors hover:bg-white/[0.09] hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-900';

/** Small caps label used above section titles and under stat values. */
export const welcomeEyebrow =
  'text-[10px] font-semibold uppercase tracking-[0.18em] text-zinc-500';

export const welcomeSectionTitle =
  'text-xl sm:text-2xl font-bold tracking-tight text-white text-center';

export const welcomeBodyText = 'text-sm leading-relaxed text-zinc-400';

/** Department accents, shared by the bootcamp template cards and team panel. */
export const WELCOME_DEPARTMENT_ACCENTS = {
  SALES: '#ef4444',
  OPERATIONS: '#3b82f6',
  FINANCE: '#10b981',
  'TECH & AI': '#a855f7',
  MARKETING: '#f97316',
  HR: '#eab308',
};

export const welcomeDepartmentAccent = (department) =>
  WELCOME_DEPARTMENT_ACCENTS[department] || '#a1a1aa';
